type OrganizationType = 'DEPARTMENT' | 'ZONE' | 'GRADE' | 'CLASS'
export default class CommonOrganization{
    /**
     * @type {string}
     * @memberof CommonOrganization
     * @name 组织类型
     */
    public type: OrganizationType;
    /**
     * @type {string}
     * @memberof CommonOrganization
     * @name 组织ID
     */
    public id: string;
    /**
     * @type {string}
     * @memberof CommonOrganization
     * @name 组织编号
     */
    public no: string;
    /**
     * @type {string}
     * @memberof CommonOrganization
     * @name 组织名称
     */
    public name: string;
    /**
     * @type {string}
     * @memberof CommonOrganization
     * @name 上级组织  教师部门为上级部门  行政班的上级部门为届，届的上级部门为学部
     */
    public parentId: string;
    /**
     * @type {string}
     * @memberof CommonOrganization
     * @name 层级
     */
    public level: string;
    constructor({
        type = 'DEPARTMENT',
        id = '',
        no = '',
        name = '',
        parentId = '',
        level = ''
    } = {}) {
        this.id  = id
        this.no  = no
        this.name  = name
        this.parentId  = parentId
        this.level  = level
        this.type = type as OrganizationType
    }
}